import { useCallback, useState } from 'react';

const useIsVisibleWithDismountState = () => {
  const [isMounted, setIsMounted] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const open = useCallback(() => {
    setIsMounted(true);
    setTimeout(() => {
      setIsVisible(true);
    }, 500);
  }, []);

  const close = useCallback(() => {
    setIsVisible(false);
    setTimeout(() => {
      setIsMounted(false);
    }, 500);
  }, []);

  return {
    open,
    close,
    isVisible,
    isMounted,
  };
};

export default useIsVisibleWithDismountState;
